import z from "zod";

export const schema = z.object({
	email: z.email("Email is required"),
	password: z.string().min(6, "Password is required"),
	rememberMe: z.boolean().optional(),
});

export type Schema = z.infer<typeof schema>;
